import { promise } from '../../../helpers';
import { validateCorporateEntity } from '../../../views/admin/corporate-entities/form/helpers';
import addCorporateEntity from './addCorporateEntity';

const addCorporateEntitiesBatch = (batchData, country = null) => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        const asyncRequests = [];
        const invalidItems = [];

        batchData.forEach(data => {
            const {
                'Entidad Corporativa': name,
                Encargado: managerName,
                'Correo Electrónico': managerEmail,
                'Código postal': postalCode,
                'ID (SAP)': idSAP,
            } = data;

            const item = {
                name,
                idSAP: idSAP || '',
                managerName,
                managerEmail,
                postalCode,
                counters: {
                    booksCounter: 0,
                    facilitatorsCounter: 0,
                    groupsParticipantsCounter: 0,
                    learningCommunitiesCounter: 0,
                },
            };

            if (country) {
                item.countryId = country.id;
                item.countryName = country.name;
            }

            if (validateCorporateEntity(item, { isBatch: true })) {
                asyncRequests.push(
                    dispatch(addCorporateEntity({ data: item }))
                        .then(() => {
                            return promise({
                                success: true,
                                item,
                            });
                        })
                        .catch(() => {
                            return promise({
                                success: false,
                                item,
                            });
                        }),
                );
            } else {
                invalidItems.push(item);
            }
        });

        return Promise.all(asyncRequests).then(responses => {
            const completed = responses.filter(res => res.success).length;
            const failed = responses.filter(res => !res.success).length;
            const invalid = invalidItems.length;

            return promise({
                completed,
                failed,
                invalid,
            });
        });
    };
};

export default addCorporateEntitiesBatch;
